import videos from '../utils/videos';
const projets = {
    init() {
        videos.init();
        //this.initSwipers();
    },
    initSwipers() {
        // const swiper_annonces = new Swiper('.__galerie_swipe', {
        //     direction: 'horizontal',
        //     spaceBetween: 30,
        //     breakpoints: {
        //         0: {
        //             slidesPerView: 1.1,
        //         },
        //         600: {
        //             slidesPerView: 1.4,
        //         },
        //         900: {
        //             slidesPerView: 2.3,
        //         },
        //         1300: {
        //             slidesPerView: 2.5,
        //         }
        //     }
        // });
    },
};

export default projets;
